export const PRIMARY = '#E73B27';
export const SECONDARY = '#2c1d10';
export const RED = '#ED6D48';
export const GREEN = '#42B549';
